import { useContext, useEffect } from "react";
import { getUserRepos } from "../../context/github/GithubActions";
import GithubContext from "../../context/github/GithubContext";
import RepoItems from "./RepoItems";

const Projects = () => {
    const { repos, dispatch } = useContext(GithubContext);
    useEffect(() => {
        const getUserData = async () => {
            const userRepoData = await getUserRepos();
            dispatch({ type: 'GET_REPOS', payload: userRepoData })
        }
        getUserData();
    }, [dispatch]);

    return (
        <div
            name="projects"
            className="py-4 md:py-10  w-full bg-gradient-to-b from-gray-800 to-black text-white h-auto"
        >
            <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
                <div className="">
                    <p className="text-3xl md:text-4xl font-bold inline border-b-4 border-gray-500">
                        Projects
                    </p>
                    <p className="py-6 text-base md:text-xl">Check out some of my work right here</p>
                </div>

                {/* This is grid div */}
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-2 md:gap-8">
                    {
                        repos.length !== 0 ? repos.map((repo) => (
                            <RepoItems key={repo.id} repo={repo} />
                        )) : (<p className="text-white text-lg font-semibold">No Public Repository Yet</p>)
                    }
                </div>
            </div>
        </div>
    );
};

export default Projects;





// const portfolios = [
//     {
//         id: 1,
//         src: arrayDestruct,
//     },
//     {
//         id: 2,
//         src: reactParallax,
//     },
//     {
//         id: 3,
//         src: navbar,
//     },
//     {
//         id: 4,
//         src: reactSmooth,
//     },
//     {
//         id: 5,
//         src: installNode,
//     },
//     {
//         id: 6,
//         src: reactWeather,
//     },
// ];



// {
//     portfolios.map(({ id, src }) => (
//         // This is for card
//         <div key={id} data-aos="zoom-in-up" className="shadow-md shadow-gray-600 rounded-lg">
//             <img
//                 src={src}
//                 alt=""
//                 className="rounded-md duration-200 hover:scale-105"
//             />
//             <div className="flex items-center justify-center">
//                 <button className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105">
//                     Demo
//                 </button>
//                 <button className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105">
//                     Code
//                 </button>
//             </div>
//         </div>
//     ))
// } 